<template>
  <div
    style="padding:10px 5px;height:calc(100% - 20px)"
    class="uk-position-relative">
    <v-search
      v-bind="searchAttrs"
      @searchFn="search"
      @deleteFn="mulDel"
      @resetFn="resetFn"
    />
    <SuperTable
      ref="stable"
      style="height:calc(100% - 150px)"
      :req="exPage"
      :params="[searchAttrs.SearchForm]"
      :columns="columns"
      :selection="true"
    >
      <template #operation="{ row }">
        <i
          class="iconfont icon-gongdanqueren cursor-pointer mr-5"
          :title="$t('integration.handle')"
          @click="handle(row)"
        ></i>
        <i
          class="iconfont icon-git-branch-line cursor-pointer mr-5"
          :title="$t('integration.sign')"
          @click="remark(row)"
        ></i>
        <i
          class="el-icon-document cursor-pointer mr-5"
          :title="$t('integration.details')"
          @click="detail(row)"
        ></i>
        <i
          class="el-icon-delete cursor-pointer"
          :title="$t('public.btn_delete')"
          @click="del(row)"
        ></i>
      </template>
    </SuperTable>

    <div class="question">
      <span class="filter-label">{{ $t('public.filter') }}</span>
      <el-select v-model="type" multiple :placeholder="$t('integration.display_info')"
         :style="{ width: selectWidth }"
         @change="searchListInvalidMsg">
        <el-option
          v-for="item in invalidMsg"
          :key="item.value"
          :label="$t(item.label)"
          :value="item.value">
          <el-checkbox disabled class="my-checkbox">
            <i v-if="type.findIndex(_ => _ === item.value) !== -1" class="el-icon-check my-checkbox-check"></i>
            {{ $t(item.label) }}
          </el-checkbox>
          <div class="info-icon" :style="{'background-color': item.color}"></div>
        </el-option>
      </el-select>
    </div>

    <HandleDialog :isShow="isShowHandleDialog"
      :exDetail="exDetail"
      :exId="exId"
      @close="isShowHandleDialog = false"
    />

    <RemarkDialog v-if="isShowRemarkDialog" :isShow="isShowRemarkDialog"
      :exId="exId"
      :excludeStatus="excludeStatus"
      :carrierName="remarkRow.carrier_name"
      :carrierDeviceName="remarkRow.carrier_device_name"
      :batch="false"
      @close="isShowRemarkDialog = false"
    />

    <ExDetailDia :fromInvalid="true"></ExDetailDia>
  </div>
</template>
<script>
import SuperTable from '@/components/SuperTable/SuperTable.vue'
import vSearch from '@/components/search/Search.vue'
import { exPage, delEx } from '@/api/modules/abnormal.js'

import { getColumns } from '@/pages/abnormal/invalidRule/columns.js'
import HandleDialog from '@/pages/abnormal/invalidRule/handle/HandleDialog.vue'
import RemarkDialog from '@/pages/abnormal/invalidRule/RemarkDialog.vue'
import { invalidMsg, alarmReason } from '@/utils/convert.js'
import ExDetailDia from '@/pages/abnormal/component/ExDetailDia/ExDetailDia.vue'
import bus from '@/utils/bus'

// 异常类型 code → i18n key 映射（用于搜索栏下拉框选项响应式语言切换）
const alarmReasonKeys = {
  0: 'integration.abnormal_connection',
  1: 'integration.abnormal_data',
  2: 'integration.abnormal_power_failure'
}

export default {
  props: ['detailObj'],
  components: { SuperTable, vSearch, HandleDialog, RemarkDialog, ExDetailDia },

  data () {
    return {
      invalidMsg,
      exPage,
      searchAttrs: {
        formContent: [
          {
            id: 1,
            text: 'integration.ir_type',
            type: 'select',
            paramsName: 'exCatalog',
            selectParam: [],
            isChooze: true
          },
          {
            id: 2,
            text: 'integration.ir_close',
            type: 'select',
            paramsName: 'status',
            selectParam: [
              { value: 1, label: 'public.yes' },
              { value: 0, label: 'public.no' }
            ],
            isChooze: true
          },
          {
            id: 3,
            text: 'integration.ir_abnormal_time',
            type: 'datetimerange',
            paramsName: 'time',
            isChooze: false
          }
        ],
        SearchForm: {
          status: null,
          from: null,
          to: null,
          time: [],
          carrierId: null,
          exCatalog: null,
          iDisplayLength: 15,
          iDisplayStart: 0,
          alarm: 1,
          excludeStatus: null
        },
        inline: true,
        optareBtn: [
          {
            id: 1,
            icon: '',
            text: 'integration.delete',
            method: 'deleteFn'
          }
        ]
      },
      isShowHandleDialog: false,
      exDetail: {},
      exId: null,
      isShowRemarkDialog: false,
      remarkRow: {},
      type: ['abnormal'],
      excludeStatus: null
    }
  },
  watch: {
    '$store.state.exType': {
      handler (newval) {
        const item = this.searchAttrs.formContent.find(
          item => item.paramsName === 'exCatalog'
        )
        if (item) {
          const result = []
          Object.keys(newval).forEach(key => {
            const code = newval[key].code
            result.push({
              label: alarmReasonKeys[code] || (alarmReason[code] && alarmReason[code].title) || '',
              value: code
            })
          })
          item.selectParam = result
        }
      }
    }
  },
  computed: {
    columns () {
      const _locale = this.$i18n.locale
      return getColumns()
    },
    selectWidth () {
      const n = this.type.length
      if (n === 0) return '200px'
      return (n * 80 + 40) + 'px'
    }
  },
  created () {
    if (this.detailObj) {
      this.searchAttrs.SearchForm.carrierId = this.detailObj.id || this.$route.query.id
    }
  },
  mounted () {
    this.$store.dispatch('exType')
    this.searchListInvalidMsg()
  },
  methods: {
    getList () {
      this.$refs.stable.getList()
    },
    search (params) {
      if (params.time && params.time.length > 0) {
        if (this.searchAttrs.SearchForm.propertyIsEnumerable('time')) {
          Object.defineProperty(this.searchAttrs.SearchForm, 'time', {
            value: this.searchAttrs.SearchForm.time,
            enumerable: false,
            configurable: true,
            writable: true
          })
        }
        this.searchAttrs.SearchForm.from = new Date(params.time[0]).getTime()
        this.searchAttrs.SearchForm.to = new Date(params.time[1]).getTime()
      }
      this.getList()
    },
    async mulDel () {
      const selection = this.$refs.stable.getSelection()
      if (!selection.length) {
        this.$message.warning(this.$t('integration.please_select_at_least_one_data'))
        return
      }
      this.del(selection)
    },
    resetFn () {
      const alarm = this.searchAttrs.SearchForm.alarm
      const carrierId = this.searchAttrs.SearchForm.carrierId
      this.searchAttrs.SearchForm = {
        status: null,
        from: null,
        to: null,
        time: [],
        carrierId: carrierId,
        exCatalog: null,
        iDisplayLength: 15,
        iDisplayStart: 0,
        alarm: alarm,
        excludeStatus: null
      }
      this.type = ['abnormal']
      this.searchListInvalidMsg()
    },
    del (row) {
      this.$confirm(this.$t('integration.are_you_sure_you_want_to_delete_this_exception_q')).then(() => {
        let ids = null
        if (row instanceof Array) {
          ids = row.map(item => item.id)
        } else {
          ids = [row.id]
        }
        delEx(ids).then(res => {
          switch (res.result) {
            case 200:
              this.$message.success(this.$t('integration.successfully_deleted'))
              this.getList()
              break
            case 400:
              this.$message.error(this.$t('integration.delete_failed'))
              break
          }
        })
      })
    },
    handle (row) {
      this.isShowHandleDialog = true
      this.exDetail = [row]
      this.exId = row.id
    },
    remark (row) {
      this.isShowRemarkDialog = true
      this.exId = row.id
      this.excludeStatus = row.excludeStatus
      this.remarkRow = row
    },
    detail (row) {
      bus.$emit('exDetail', {
        id: row.id
      })
    },
    searchListInvalidMsg () {
      let typeArr = []
      this.type.forEach(item => {
        if (item === 'normal') {
          typeArr.push(0)
        } else if (item === 'abnormal') {
          typeArr.push(1)
        } else {
          typeArr.push(2)
        }
      })
      this.searchAttrs.SearchForm.excludeStatus = typeArr.join()
      this.getList()
    }
  }
}
</script>
<style lang="scss" scoped>
.question {
  position: absolute;
  right: 15px;
  top: 22px;
  font-size: 18px;
  z-index: 999;
  cursor: pointer;
  color: gray;
  display: flex;
  align-items: center;
  ::v-deep.el-select__tags {
    flex-wrap: nowrap;
    overflow: hidden;
  }
}
.filter-label {
  font-size: 14px;
  margin-right: 8px;
  white-space: nowrap;
}
.info-icon {
  width: 25px;
  height: 15px;
  float: right;
  margin-top: 10px;
  margin-left: 5px;
}
.my-checkbox {
  position: relative;
  ::v-deep .el-checkbox__label {
    color: #333333 !important;
    cursor: pointer !important;
  }
  ::v-deep .el-checkbox__inner {
    color: #333333 !important;
    cursor: pointer !important;
    background-color: #FFFFFF !important;
  }
  .my-checkbox-check {
    position: absolute;
    left: 0px;
    top: 10px;
    z-index: 999;
    font-weight: bold;
  }
}
::v-deep .el-select-dropdown__item {
  &::after {
    content: '' !important;
  }
}
</style>
